class Template {
  async get(filter) {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/templates?q=${filter}`, {
      headers: {
        'x-access-token': localStorage.getItem('token')
      }
    });
    return await data.json();
  }

  async download(file) {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/templates/${file}`, {
      headers: {
        'x-access-token': localStorage.getItem('token')
      }
    });

    const blob = await data.blob();

    // Creating new object of file
    const fileURL = window.URL.createObjectURL(blob);

    // Setting various property values
    let alink = document.createElement("a");
    alink.href = fileURL;
    alink.download = file;
    alink.click();

    return;
  }

  async delete(file) {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/templates/${file}`, {
      method: 'DELETE',
      headers: {
        'x-access-token': localStorage.getItem('token')
      }
    });
    return;;
  }

  async upload(files) {
    const response = [];
    const existingFiles = (await this.get('')).map(f => f.name);

    for (const file of files) {

      if (!existingFiles.includes(file.name) || window.confirm(`${file.name} already exists. Overwrite file?`) === true) {
        const formData = new FormData();
        formData.append('file', file);

        const data = await fetch(`${process.env.REACT_APP_API_URL}/templates/upload`, {
          method: 'POST',
          headers: {
            'x-access-token': localStorage.getItem('token')
          },
          body: formData
        });

        var json = await data.json();
        if (json.error) {
          json = { ...json, name: file.name }
        }
        response.push(json);
      }
    }

    return response;
  }

  async getTags(file) {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/templates/${file}/tags`, {
      headers: {
        'x-access-token': localStorage.getItem('token')
      }
    });
    return await data.json();
  }

  async getLastUsedValues(modelId) {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/templatevalues/${modelId}`, {
      headers: {
        'x-access-token': localStorage.getItem('token')
      }
    });
    return await data.json();
  }

  async saveNewFileAndValues(templateFile, templateValues) {
    console.log(templateValues);

    await fetch(`${process.env.REACT_APP_API_URL}/templatevalues`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': localStorage.getItem('token')
      },
      body: JSON.stringify(templateValues)
    });

    const data = await fetch(`${process.env.REACT_APP_API_URL}/templates/${templateFile}/new`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': localStorage.getItem('token')
      },
      body: JSON.stringify(templateValues)
    });

    return await data.json();
  }
}

module.exports = new Template();